import { Controller } from "@hotwired/stimulus";
import { Tooltip } from "@tabler/core/dist/js/tabler.js";

export default class extends Controller {
  static targets = ["content", "preview", "full", "toggle", "expandIcon", "collapseIcon"];
  static values = { expandLabel: String, collapseLabel: String };

  connect() {
    this.expanded = false;
    this.toggleTarget.setAttribute("aria-label", this.expandLabelValue);
    this.handleDoubleClick = this.copyIsbn.bind(this);
    this.element.addEventListener("dblclick", this.handleDoubleClick);
  }

  disconnect() {
    this.element.removeEventListener("dblclick", this.handleDoubleClick);
    if (this.copyFeedbackTimeout) clearTimeout(this.copyFeedbackTimeout);
  }

  toggle() {
    const expanded = !this.expanded;
    this.expanded = expanded;
    this.previewTarget.hidden = expanded;
    this.fullTarget.hidden = !expanded;
    this.expandIconTarget.hidden = expanded;
    this.collapseIconTarget.hidden = !expanded;
    this.toggleTarget.setAttribute("aria-expanded", expanded.toString());
    this.toggleTarget.setAttribute("aria-label", expanded ? this.collapseLabelValue : this.expandLabelValue);
  }

  async copyIsbn(event) {
    const trigger = event.target.closest("[data-copyable-isbn-value]");
    if (!trigger || !this.element.contains(trigger)) return;

    event.preventDefault();
    const text = trigger.dataset.copyableIsbnValue;
    if (!text) return;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        this.execCopyFallback(text);
      }
      this.showCopyTooltip(trigger);
    } catch (_) {
      this.execCopyFallback(text);
      this.showCopyTooltip(trigger);
    }
  }

  execCopyFallback(text) {
    const temp = document.createElement("textarea");
    temp.value = text;
    temp.setAttribute("readonly", "");
    temp.style.position = "fixed";
    temp.style.left = "-9999px";
    temp.style.opacity = "0";
    document.body.appendChild(temp);
    temp.focus();
    temp.select();
    document.execCommand("copy");
    temp.remove();
  }

  showCopyTooltip(trigger) {
    if (this.copyFeedbackTimeout) clearTimeout(this.copyFeedbackTimeout);

    this.setTooltipText(trigger, trigger.dataset.copyableIsbnFeedback);
    const tooltip = Tooltip.getOrCreateInstance(trigger);
    tooltip.show();

    this.copyFeedbackTimeout = window.setTimeout(() => {
      trigger.addEventListener("hidden.bs.tooltip", () => {
        tooltip.dispose();
        trigger.removeAttribute("title");
        trigger.removeAttribute("data-bs-original-title");
      }, { once: true });
      tooltip.hide();
      this.copyFeedbackTimeout = null;
    }, 1500);
  }

  setTooltipText(trigger, text) {
    trigger.setAttribute("title", text);
    trigger.setAttribute("data-bs-original-title", text);

    const tooltip = Tooltip.getOrCreateInstance(trigger);
    if (tooltip.setContent) {
      tooltip.setContent({ ".tooltip-inner": text });
    }
  }
}
